import { c as _c } from "react/compiler-runtime";
import { Avatar, Box, Button, HStack, Input, SimpleGrid, Stack, Text, VStack, Field } from '@chakra-ui/react';
import { UploadButton } from '@src/components/sco/Account/UploadButton';
import { HelpModal } from '@src/components/sco/Requests/RequestBuilder/FormSections/HelpModal';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { UpsertGroupRequestInput } from '@src/graphql-types';
import { scoBackendUrl } from '@src/lib/startups-url';
import React, { useEffect, useState } from 'react';
export const UserProfileSection: React.FC<RequestBuilderFormProps> = props => {
  const $ = _c(85);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const groupRequest = props.groupRequest;
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [firstName, setFirstName] = useState(groupRequest.requestingUser.firstName || "");
  const [lastName, setLastName] = useState(groupRequest.requestingUser.lastName || "");
  const [pictureUrl, setPictureUrl] = useState(groupRequest.requestingUser.pictureUrl || "");
  let t0;
  if ($[0] !== groupRequest.requestingUser.firstName || $[1] !== groupRequest.requestingUser.lastName) {
    t0 = () => {
      setFirstName(groupRequest.requestingUser.firstName);
      setLastName(groupRequest.requestingUser.lastName);
    };
    $[0] = groupRequest.requestingUser.firstName;
    $[1] = groupRequest.requestingUser.lastName;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== groupRequest.requestingUser.firstName) {
    t1 = [groupRequest.requestingUser.firstName];
    $[3] = groupRequest.requestingUser.firstName;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== firstName || $[6] !== lastName || $[7] !== pictureUrl || $[8] !== props) {
    t2 = async t3 => {
      const next = t3 === undefined ? _temp : t3;
      if (!props.groupRequest.groupRequestId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertGroupRequest({
        variables: {
          input: {
            groupRequestId: props.groupRequest.groupRequestId,
            upsertRequestingUserInput: {
              userId: props.groupRequest.requestingUser.userId,
              firstName,
              lastName,
              pictureUrl
            }
          } as UpsertGroupRequestInput
        }
      });
      if (next) {
        next();
      }
    };
    $[5] = firstName;
    $[6] = lastName;
    $[7] = pictureUrl;
    $[8] = props;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const performSave = t2;
  let t3;
  if ($[10] !== getBreakpointValue) {
    t3 = getBreakpointValue([1, 2]);
    $[10] = getBreakpointValue;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Field.Label>First Name</Field.Label>;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== performSave) {
    t5 = ev => performSave();
    $[13] = performSave;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => setFirstName(e.target.value);
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== firstName || $[17] !== t5) {
    t7 = <Field.Root>{t4}<Input placeholder="John" size="sm" value={firstName} onBlur={t5} onChange={t6} /></Field.Root>;
    $[16] = firstName;
    $[17] = t5;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Field.Label>Last Name</Field.Label>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== performSave) {
    t9 = ev_0 => performSave();
    $[20] = performSave;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e_0 => setLastName(e_0.target.value);
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== lastName || $[24] !== t9) {
    t11 = <Field.Root>{t8}<Input placeholder="Doe" size="sm" value={lastName} onBlur={t9} onChange={t10} /></Field.Root>;
    $[23] = lastName;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t3 || $[28] !== t7) {
    t12 = <SimpleGrid columns={t3} gap={4}>{t7}{t11}</SimpleGrid>;
    $[26] = t11;
    $[27] = t3;
    $[28] = t7;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Field.Label>Photo</Field.Label>;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== getBreakpointValue) {
    t14 = getBreakpointValue(["column", "row"]);
    $[31] = getBreakpointValue;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== firstName || $[34] !== lastName) {
    t15 = [firstName, lastName];
    $[33] = firstName;
    $[34] = lastName;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const t16 = t15.join(" ");
  let t17;
  if ($[36] !== t16) {
    t17 = t16.trim();
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17) {
    t18 = <Avatar.Fallback name={t17} />;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== pictureUrl) {
    t19 = <Avatar.Image src={pictureUrl} />;
    $[40] = pictureUrl;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t18 || $[43] !== t19) {
    t20 = <Box textAlign="center"><Avatar.Root size="2xl">{t18}{t19}</Avatar.Root></Box>;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = ["jpeg", "jpg", "png"];
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = scoBackendUrl("/assets/upload-image");
    t23 = url => {
      setPictureUrl(url);
    };
    $[46] = t22;
    $[47] = t23;
  } else {
    t22 = $[46];
    t23 = $[47];
  }
  let t24;
  if ($[48] !== getBreakpointValue) {
    t24 = getBreakpointValue(["xs", "sm"]);
    $[48] = getBreakpointValue;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t24) {
    t25 = {
      size: t24
    };
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== props.groupRequest.requestingUser.userId) {
    t26 = {
      attachmentType: "User",
      attachmentId: props.groupRequest.requestingUser.userId,
      contextKey: "profile-picture"
    };
    $[52] = props.groupRequest.requestingUser.userId;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t25 || $[55] !== t26) {
    t27 = <Box><UploadButton afterError={_temp2} allowedExtensions={t21} maxSizeInBytes={10000000} uploadUrl={t22} afterSuccess={t23} buttonProps={t25} storedFile={t26}>Upload a Photo</UploadButton></Box>;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Box>or</Box>;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== getBreakpointValue) {
    t29 = getBreakpointValue(["xs", "sm"]);
    $[58] = getBreakpointValue;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = () => {
      setPictureUrl(undefined);
    };
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t29) {
    t31 = <Button size={t29} variant="outline" onClick={t30}>Remove</Button>;
    $[61] = t29;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t27 || $[64] !== t31) {
    t32 = <Stack align="center" direction="row" justify="center" width="full">{t27}{t28}{t31}</Stack>;
    $[63] = t27;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Text color="colorPalette.fg/60" fontSize="xs" marginTop="0.5em" textAlign="center">A square JPEG or PNG under 10MB is best.</Text>;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== t32) {
    t34 = <Box flexGrow={1} width="full">{t32}{t33}</Box>;
    $[67] = t32;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t14 || $[70] !== t20 || $[71] !== t34) {
    t35 = <Field.Root>{t13}<Stack align="center" bgColor="colorPalette.muted/50" borderRadius="md" direction={t14} justify="center" padding={4} width="full">{t20}{t34}</Stack></Field.Root>;
    $[69] = t14;
    $[70] = t20;
    $[71] = t34;
    $[72] = t35;
  } else {
    t35 = $[72];
  }
  let t36;
  if ($[73] !== performSave || $[74] !== props) {
    t36 = <HStack justify="flex-end" paddingY={2} width="full"><Button size="xs" variant="cta" onClick={async e_1 => {
        await performSave(() => props.onNextSection ? props.onNextSection() : null);
      }}>{"Save & Continue"}</Button></HStack>;
    $[73] = performSave;
    $[74] = props;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] !== t12 || $[77] !== t35 || $[78] !== t36) {
    t37 = <VStack align="stretch" gap={4} padding={4}>{t12}{t35}{t36}</VStack>;
    $[76] = t12;
    $[77] = t35;
    $[78] = t36;
    $[79] = t37;
  } else {
    t37 = $[79];
  }
  let t38;
  if ($[80] !== showHelpModal) {
    t38 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[80] = showHelpModal;
    $[81] = t38;
  } else {
    t38 = $[81];
  }
  let t39;
  if ($[82] !== t37 || $[83] !== t38) {
    t39 = <>{t37}{t38}</>;
    $[82] = t37;
    $[83] = t38;
    $[84] = t39;
  } else {
    t39 = $[84];
  }
  return t39;
};
function _temp() {}
function _temp2(err) {
  return alert(`Upload failed: ${err.toString()}`);
}